// Define the FAQ item structure
export type FAQItem = {
  id: number;
  question: string;
  answer: string;
  category: string;
};

// FAQ data for Argentine operations
export const faqItems: FAQItem[] = [
  {
    id: 1,
    question: '¿Qué medios de transporte llegan hasta la empresa?',
    answer: 'Podés llegar en transporte público utilizando las siguientes líneas de colectivo: 126, 180, 185, 298.',
    category: 'Información General'
  },
  {
    id: 2,
    question: '¿Qué medios de pago aceptan?',
    answer: 'Aceptamos una amplia variedad de medios de pago para tu comodidad:\n\n• Efectivo\n• Tarjetas de débito: Cabal, Visa, MasterCard\n• Mercado Pago (también compatible con otras billeteras virtuales como Modo)\n• Transferencia bancaria\n• Cheques físicos o electrónicos (solo con autorización previa)',
    category: 'Pagos y Facturación'
  },
  {
    id: 3,
    question: '¿Tienen sucursales?',
    answer: 'No, actualmente no contamos con sucursales. Toda la atención y entrega se realiza desde nuestra sede central en Av. Crovara 2000/2014, La Tablada, Buenos Aires.',
    category: 'Información General'
  },
  {
    id: 4,
    question: '¿Venden productos de laboratorio?',
    answer: 'Sí, ofrecemos una amplia variedad de productos de laboratorio. Consultá nuestro catálogo para conocer toda nuestra oferta disponible.',
    category: 'Productos'
  },
  {
    id: 5,
    question: '¿Venden reactivos analíticos?',
    answer: 'Sí, contamos con reactivos analíticos de distintas marcas y concentraciones. Consultá nuestro catálogo para encontrar el producto que necesitás.',
    category: 'Productos'
  },
  {
    id: 6,
    question: '¿Venden productos para mantenimiento de piletas?',
    answer: 'Sí, disponemos de productos específicos para el mantenimiento de piletas, tanto domiciliarias como deportivas.',
    category: 'Productos'
  },
  {
    id: 7,
    question: '¿Cómo puedo retirar mis productos?',
    answer: 'Todos nuestros productos están disponibles para retiro en nuestra sede central ubicada en Av. Crovara 2000/2014, La Tablada, Buenos Aires. Una vez que tu pedido esté listo, recibirás una notificación para coordinar el retiro.',
    category: 'Pedidos y Entregas'
  },
  {
    id: 8,
    question: '¿Ofrecen asesoría técnica sobre el uso de los productos?',
    answer: 'Sí, contamos con un equipo de especialistas que pueden brindarte asesoría técnica sobre el uso, manipulación y aplicaciones de nuestros productos. Este servicio está disponible para todos nuestros clientes sin costo adicional.',
    category: 'Soporte Técnico'
  },
  {
    id: 9,
    question: '¿Cuál es el pedido mínimo?',
    answer: 'El pedido mínimo varía según el producto y tipo de cliente. Contactanos para conocer las condiciones específicas para tu caso.',
    category: 'Pedidos y Entregas'
  },
  {
    id: 10,
    question: '¿Realizan envíos al interior del país?',
    answer: 'Sí, realizamos envíos a todo el país a través de transportes de confianza. Los costos y tiempos de entrega varían según la zona de destino.',
    category: 'Pedidos y Entregas'
  },
  {
    id: 11,
    question: '¿Cómo garantizan la calidad de sus productos?',
    answer: 'Cumplimos con todas las normativas vigentes para la comercialización de productos químicos y mantenemos rigurosos controles de calidad en todos nuestros procesos.',
    category: 'Calidad'
  },
  {
    id: 12,
    question: '¿Cómo solicito una cotización?',
    answer: 'Podés solicitar una cotización a través de nuestro formulario online en la sección "Cotizar", enviando un email o contactándonos telefónicamente. Nuestro equipo te responderá a la brevedad.',
    category: 'Pedidos y Entregas'
  }
];

// Group FAQ items by category
export const groupedByCategory = faqItems.reduce((acc, item) => {
  if (!acc[item.category]) {
    acc[item.category] = [];
  }
  acc[item.category].push(item);
  return acc;
}, {} as Record<string, FAQItem[]>);
